import type { FormField } from '@cli-types/core-engine/schema.js'

export function ensureFormChildFields(field: FormField): FormField[] {
  if (!Array.isArray(field.fields)) {
    field.fields = []
  }
  return field.fields
}
